var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRtThruarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 112,
    viewBox: "0 0 162 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.0001V13.0001H46C58.5 13 72 18.4999 83 30.0001C94 41.5002 98 54.0001 98 66.0001V86H110L84 112L58 86H70V68.0001C70 60.0001 68.5 54.0001 62.5 48.0001C56.5 42.0001 50.8552 39.0001 43 39.0001H0Z",
    fill: "#005DAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.0001L134 13V40H0V13.0001Z",
    fill: "#005DAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162 26L132.75 51.9808V0.0192871L162 26Z",
    fill: "#005DAA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtThruarrow);
export default __webpack_public_path__ + "static/media/RT_thruarrow.140b1b7b31a5e63e4167d1e640b6b8aa.svg";
export { ForwardRef as ReactComponent };